"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const PREFIX = "RadioPane";
exports.classes = {
    label: `${PREFIX}-label`,
    descriptionContainer: `${PREFIX}-descriptionContainer`,
    btnContainer: `${PREFIX}-btnContainer`,
    iconBtn: `${PREFIX}-iconBtn`,
    infoIcon: `${PREFIX}-infoIcon`,
    cancelIcon: `${PREFIX}-cancelIcon`,
    collapseFeature: `${PREFIX}-collapseFeature`,
    input: `${PREFIX}-input`,
    pane: `${PREFIX}-pane`,
    checkedIcon: `${PREFIX}-checkedIcon`,
    header: `${PREFIX}-header`,
    title: `${PREFIX}-title`,
    content: `${PREFIX}-content`,
    hr: `${PREFIX}-hr`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    marginTop: "8px",
    display: "block",
    [`&.${exports.classes.collapseFeature}`]: {
        display: "flex",
        [`.${exports.classes.label}`]: {
            flexGrow: 1
        }
    },
    [`.${exports.classes.label}`]: {
        display: "block",
        "& + &": {
            marginTop: "8px"
        }
    },
    [`.${exports.classes.descriptionContainer}`]: {
        overflow: "hidden",
        transition: "height 280ms cubic-bezier(0.4, 0, 0.2, 1)"
    },
    [`.${exports.classes.btnContainer}`]: {
        display: "flex",
        alignItems: "center",
        height: "60px",
        marginLeft: "8px"
    },
    [`.${exports.classes.iconBtn}`]: {
        minWidth: "42px",
        width: "42px",
        height: "42px",
        borderRadius: 0
    },
    [`.${exports.classes.infoIcon}`]: {
        width: "24px",
        height: "24px",
        color: theme.colours.inter
    },
    [`.${exports.classes.cancelIcon}`]: {
        width: "24px",
        height: "24px",
        color: "#70706f"
    },
    [`.${exports.classes.input}`]: {
        position: "absolute",
        clip: "rect(0 0 0 0)",
        [`&:focus + .${exports.classes.pane}`]: {
            border: `1px solid ${theme.colours.accent}`
        },
        [`&:checked + .${exports.classes.pane}`]: {
            border: `2px solid ${theme.colours.accent}`,
            backgroundColor: theme.colours.white,
            [`.${exports.classes.checkedIcon}`]: {
                display: "block"
            }
        },
        [`&:not(:checked) + .${exports.classes.pane}`]: {
            cursor: "pointer",
            "&:hover": {
                boxShadow: "0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)",
                backgroundColor: theme.colours.white,
                [`.${exports.classes.title}`]: {
                    color: theme.colours.focus
                }
            }
        }
    },
    [`.${exports.classes.pane}`]: {
        display: "flex",
        flexFlow: "column nowrap",
        alignItems: "flex-start",
        justifyContent: "stretch",
        boxShadow: "0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)",
        border: `1px solid ${theme.colours.storm}`,
        borderRadius: "3px",
        overflow: "hidden",
        padding: "0 30px",
        cursor: "default",
        backgroundColor: theme.colours.pearl
    },
    [`.${exports.classes.checkedIcon}`]: {
        display: "none",
        height: "32px",
        color: theme.colours.accent,
        marginLeft: "16px"
    },
    [`.${exports.classes.header}`]: {
        display: "flex",
        flexFlow: "row nowrap",
        justifyContent: "flex-start",
        alignItems: "center",
        height: "60px"
    },
    [`.${exports.classes.title}`]: {
        color: theme.colours.inter,
        lineHeight: 1
    },
    [`.${exports.classes.content}`]: {
        width: "100%",
        paddingBottom: "30px"
    },
    [`.${exports.classes.hr}`]: {
        color: theme.colours.storm,
        marginBottom: "24px"
    }
}));
//# sourceMappingURL=data:application/json;base64,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